import axios from "axios";
import storage from "../helpers/storage";
import logger from "../helpers/logger";
import { NotificationManager } from "../components/common/react-notifications";
import { createBrowserHistory } from "history";
import { logoutUser } from "../redux/slices/auth.slice";

let history = null;

const headerTokenKey = "X-Auth-Token";
const httpService = axios.create({});

// REQUEST INTERCEPTOR
httpService.interceptors.request.use(
  (config) => {
    // logger.log("request intercepted.");
    // logger.log("method: ", config.method);
    // logger.log("baseURL", config.baseURL);
    // logger.log("url", config.url);
    // logger.log("requestData: ", config.data);
    // logger.log("header info: ", config.headers);

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// RESPONSE INTERCEPTOR
httpService.interceptors.response.use(
  (response) => {
    // logger.log("response intercepted");
    // logger.log("status: ", response.status);
    // logger.log("response: ", response);

    const { responseCode, responseDescription } = response.data;
    if (responseCode === "14") {
      storage.resetAll();
      setTimeout(() => window.location.reload(), 3000);
    }
    return response;
  },
  (error) => {
    if (error.response) {
      // Request made and server responded
      const { status } = error.response;
      const alertMessage = `Request made and server responded with response code [${status}]`;
      // logger.log("[ALERT] ", alertMessage);
    } else if (error.request) {
      // 'The request was made but no response was received'

      const alertMessage = `[request-timeout] - The request was made but no response was received`;
      // logger.log("[ALERT] ", alertMessage);
    } else {
      // Something happened in setting up the request that triggered an Error
      const alertMessage = `Something happened in setting up the request that triggers an Error`;
      // logger.log("[ALERT] ", alertMessage);
    }

    return Promise.reject(error);
  }
);

const configAuthHeader = (token) => {
  httpService.defaults.headers.common[headerTokenKey] = token;
};

function setHistory(h) {
  // logger.info("set history");
  // logger.debug("set history: ", h);
  history = h;
}

// SOLVES REFRESH ISSUE
const authToken = storage.getAuthToken();
if (authToken) httpService.defaults.headers.common[headerTokenKey] = authToken;

export default {
  post: httpService.post,
  get: httpService.get,
  put: httpService.put,
  patch: httpService.patch,
  delete: httpService.delete,

  setHistory: setHistory,
  configAuthHeader: configAuthHeader,
};
